import { useCallback } from "react";
import ReactGA from "react-ga4";

const IS_PRODUCTION =
  process.env.NODE_ENV === "production" &&
  typeof window !== "undefined" &&
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1";

const send = (eventName, params = {}) => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );

  if (IS_PRODUCTION) {
    ReactGA.event(eventName, cleanParams);
  } else {
    console.group(`%c[YogGoalsAnalytics] ${eventName}`, "color:#0F9D58;font-weight:bold;");
    if (Object.keys(cleanParams).length > 0) console.table(cleanParams);
    else console.log("(no params)");
    console.groupEnd();
  }
};

const useYogGoalsAnalytics = () => {
  const trackPageView = useCallback((title, url) => {
    send("yog_goals_page_view", { page_title: title, page_location: url });
  }, []);

  const trackGoalSelect = useCallback((goal, goalIndex) => {
    send("yog_goals_select", {
      goal_id: goal?.id ?? "",
      goal_name: goal?.title ?? "",
      goal_index: goalIndex,
    });
  }, []);

  const trackTrialClick = useCallback((goal) => {
    send("yog_goals_trial_click", {
      goal_id: goal?.id ?? "",
      goal_name: goal?.title ?? "",
    });
  }, []);

  return { trackPageView, trackGoalSelect, trackTrialClick };
};

export default useYogGoalsAnalytics;
